<template>
    <div>
        <div
            v-if="!changingStatus"
            class="d-flex align-items-center">
            <pc-button
                v-if="canChangeStatus"
                id="ChangePaymentStatusBtn"
                class="me-2"
                v-on:click="changingStatus = true">
                {{ changeStatusButtonText }}
            </pc-button>
            <pc-button
                id="ViewPaymentHistoryBtn"
                v-on:click="viewPaymentHistory(charge)">
                {{ viewHistoryButtonText }}
            </pc-button>
        </div>
        <div v-else>
            <change-payment-status-control
                v-bind:charge="charge"
                v-bind:current-payment-provider="currentPaymentProvider"
                v-bind:adapter-options="adapterOptions"
                v-on:change-status-cancel="changingStatus = false"
                v-on:edit-status="onEditStatus" />
        </div>
    </div>
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/paymentHistoryActionRow.i18n.js";
    import changePaymentStatusControl from "EPayments/changePaymentStatusControl.vue";
    import { canChangeStatusForCharge } from "EPayments/ePayments";

    export default {
        components: {
            changePaymentStatusControl
        },
        props: {
            charge: { type: Object, required: true },
            currentPaymentProvider: { type: Number, required: true },
            adapterOptions: { type: Object, required: true },
            isReadOnly: { type: Boolean, required: false, default: true },
            onEditStatus: { type: Function, required: false, default: () => {} }
        },
        emits: ["view-payment-history"],
        data() {
            return {
                changingStatus: false
            };
        },
        computed: {
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            ),
            canChangeStatus() {
                return !this.isReadOnly && canChangeStatusForCharge(this.charge, this.adapterOptions);
            }
        },
        methods: {
            viewPaymentHistory(charge) {
                this.$emit("view-payment-history", charge);
            }
        }
    };
</script>
